import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  FacebookPostBody,
  FacebookRequestParams
} from '@fb-tool-front/shared/interfaces/shared.type';
import { environment } from '@fb-tool-front/environments/environment';
import { merge, Observable, of } from 'rxjs';
import { catchError, distinctUntilChanged, map, shareReplay } from 'rxjs/operators';
import { AppStateService } from './app-state.service';
import param from 'jquery-param';
import { AuthService } from './auth.service';
import { Client, User } from '@fb-tool-front/shared/interfaces/auth.type';

@Injectable({
  providedIn: 'root'
})
export class FacebookService {
  private FACEBOOK_URL = `${environment.host}/api/facebook`;
  private meObservable$: Observable<User>;
  private hasFb2fa$: Observable<any>;

  constructor(
    private http: HttpClient,
    private appStateService: AppStateService,
    private authService: AuthService
  ) {
    merge(
      this.authService.client$.pipe(
        distinctUntilChanged((x: Client, y: Client) => x?.id === y?.id)
      ),
      this.authService.user$.pipe(
        distinctUntilChanged((x: User, y: User) => x?.username === y?.username)
      )
    ).subscribe(_ => {
      this.meObservable$ = this.getNewMeObservable();
      this.hasFb2fa$ = this.getHasFb2faObservable();
    });
  }

  public get(params: FacebookRequestParams): Observable<any> {
    return this.http.get(this.FACEBOOK_URL, {
      params: new HttpParams({ fromString: param(params) })
    });
  }

  public post(body: FacebookPostBody): any {
    return this.http.post(this.FACEBOOK_URL, body);
  }

  public getUserWithMeRules(): Observable<User> {
    return this.meObservable$;
  }

  public getUserWithFb2FaRules(): Observable<any> {
    return this.hasFb2fa$.pipe(
      map(hasFb2Fa => ({
        hasFb2Fa: hasFb2Fa?.has_fb_2fa,
        hasFbBusiness: hasFb2Fa?.has_fb_business
      }))
    );

    // TODO check why we need getUserWithMeRules observable here

    // return forkJoin([this.getUserWithMeRules(), this.hasFb2fa$]).pipe(
    //   map(([user, hasFb2Fa]: [User, any]) => ({
    //     ...user,
    //     hasFb2Fa: hasFb2Fa.has_fb_2fa,
    //     hasFbBusiness: hasFb2Fa.has_fb_business
    //   }))
    // );
  }

  public getHasFb2faObservable() {
    return this.http.get(`${this.FACEBOOK_URL}/user/fb2fa`).pipe(
      catchError(error => {
        console.error(error);
        const errorMessage = error?.error?.error?.message
          ? error?.error?.error?.message
          : error.message
          ? error.message
          : error;
        this.appStateService.navigateToError({
          severity: 'error',
          message: errorMessage
        });

        return of(null);
      }),
      shareReplay(1)
    );
  }

  private getNewMeObservable() {
    return this.http.get<User>(`${this.FACEBOOK_URL}/user/me`);
  }

  public getAuthUrl() {
    return this.http.get<{ url: string }>(`${this.FACEBOOK_URL}/auth/login`);
  }
}
